<template>
  <div>
    <div class="addFormBox">
      <!--基础数据-->
      <div class="title">{{ $t('basicData.UnderlyingData') }}</div>
      <el-form
        ref="queryForm"
        size="small"
        :rules="rules"
        :model="formData"
        label-position="top"
      >
        <el-row :gutter="10">
          <!--报价方案名称-->
          <el-col :span="6">
            <el-form-item :label="$t('basicData.TheNameOfTheQuoteProposal')" prop="name">
              <el-input
                v-model.trim="formData.name"
                :placeholder="$t('orderDetails.pleaseInput')"
                clearable
                maxlength="100"
                show-word-limit
              />
            </el-form-item>
          </el-col>

          <!--有效期开始-->
          <el-col :span="6">
            <el-form-item :label="$t('basicData.TheValidityPeriodBegins')" prop="startOfValidityPeriod">
              <el-date-picker
                v-model="formData.startOfValidityPeriod"
                type="datetime"
                :format="$i18n.locale === 'zh' ? zhDate : ptDate"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%;"
                :disabled="isDisableData"
                :picker-options="pickerOptions"
                :placeholder="$t('basicData.SelectADatetime')"
              />
            </el-form-item>
          </el-col>

          <!--业务类型-->
          <el-col :span="6">
            <el-form-item :label="$t('collectionCenter.businessT')" prop="businessType">
              <el-select
                v-model="formData.businessType"
                style="width: 100%;"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                @change="handleBusinessTypeChange"
              >
                <el-option
                  v-for="item in PAYABLE_TYPE"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!--业务场景-->
          <el-col v-if="formData.businessType === 7" :span="6">
            <el-form-item :label="$t('basicData.BusinessScenario')" prop="quoteType">
              <el-select
                v-model="formData.quoteType"
                style="width: 100%;"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                @change="changeQuoteType"
              >
                <el-option :key="1" :label="$t('mdfeTranslate.Entrega')" :value="1" />
                <el-option :key="2" :label="$t('mdfeTranslate.Coleta')" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <!---->

          <!-- 如果"业务类型"选中"第三方揽收"，则显示揽收方式并且必填 -->
          <el-col v-if="formData.businessType === 2 || formData.quoteType === 2" :span="6">
            <el-form-item
              :label="$t('collectionCenter.lanshouTypee')"
              prop="collectType"
              :rules="{
                required: true,
                message: $t('basicData.CannotBeEmpty'),
                trigger: ['blur', 'change']
              }"
            >
              <el-select
                v-model="formData.collectType"
                :placeholder="$t('basicData.PleaseSelect')"
                style="width: 100%;"
                @change="handleCollectTypeChange"
              >
                <el-option
                  v-for="item in COLLECT_TYPE"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 如果"业务类型"选中"AJD/DSP/MDD"，则显示货物类型 -->
          <el-col v-if="shouldShowCargoType" :span="6">
            <el-form-item
              :label="$t('placeOrder.cargoType')"
              prop="cargoType"
              :rules="getCargoTypeRules"
            >
              <el-select
                v-model="formData.cargoType"
                :placeholder="$t('basicData.PleaseSelect')"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in CARGO_TYPE"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
                <!-- :disabled="isOptionDisabled(item.value, 1)"-->
              </el-select>
            </el-form-item>
          </el-col>

          <!--业务类型不为运输才显示分区方案-->
          <el-col v-if="shouldShowPartitionScheme" :span="6">
            <el-form-item
              :label="$t('basicData.PartitionSchemeName')"
              prop="partitionId"
              :rules="{ required: formData.businessType === 6, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
            >
              <el-select
                v-model="formData.partitionId"
                :placeholder="$t('basicData.PleaseSelect')"
                style="width: 100%;"
                filterable
                clearable
                @change="handlePartitionChange"
              >
                <el-option
                  v-for="item in partitionList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!--业务类型为干支线才显示运输类型-->
          <el-col v-if="isTransportationBusiness" :span="6">
            <el-form-item
              :label="$t('basicData.transportType')"
              prop="transportType"
            >
              <el-select
                v-model="formData.transportType"
                :placeholder="$t('basicData.PleaseSelect')"
                style="width: 100%;"
                @change="changeTransportType"
              >
                <el-option :label="$t('basicData.trunkLine')" :value="1" />
                <el-option :label="$t('basicData.branchLine')" :value="2" />
                <el-option :label="$t('collectionCenter.lanshou')" :value="3" />
                <el-option :label="$t('basicData.CollectionFM')" :value="4" />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 业务类型为干支线才显示报价类型/运输类型为揽收FM时禁用 -->
          <el-col v-if="isTransportationBusiness" :span="6">
            <el-form-item
              :label="$t('basicData.QuotationType')"
              prop="quoteType"
            >
              <el-select
                v-model="formData.quoteType"
                :placeholder="$t('basicData.PleaseSelect')"
                :disabled="formData.transportType === 4"
                style="width: 100%;"
                @change="changeQuotationType"
              >
                <el-option :label="$t('basicData.VehicleLineQuotation')" :value="1" />
                <el-option :label="$t('basicData.GeneralQuotation')" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 应付主体-->
          <el-col :span="6">
            <el-form-item
              :label="$t('basicData.PayablePrincipal')"
              prop="payableEntityId"
              :rules="{ required: formData.businessType !== 2, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
            >
              <!-- 运输主体  -->
              <ElSelectV2
                v-if="isTransportationBusiness"
                v-model="formData.payableEntityId"
                :options="transportationProviderList"
                filterable
                size="small"
                :placeholder="$t('operationCenter.PleaseSelect')"
                style="width: 100%"
                @change="handleProviderChange"
              />
              <!-- 派送主体-->
              <el-select
                v-else
                v-model="formData.payableEntityId"
                filterable
                :placeholder="$t('spareNumberPoo.Only10AreDisplayed')"
                style="width: 100%;"
                remote
                clearable
                :remote-method="handleProviderSearch"
                @change="handleProviderChange"
              >
                <el-option
                  v-for="item in providerData"
                  :key="item.id"
                  :label="`${item.providerBody}（${item.providerName}）（${item.code}）`"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!--网点（运输/邮局派送不显示）-->
          <el-col v-if="shouldShowOutlets" :span="6">
            <el-form-item
              :label="$t('basicData.Outlets')"
              prop="siteIds"
            >
              <!--              <el-select-->
              <!--                v-model="formData.siteIds"-->
              <!--                filterable-->
              <!--                clearable-->
              <!--                :multiple="!editData.id"-->
              <!--                :placeholder="$t('basicData.PleaseSelect')"-->
              <!--                style="width: 100%;"-->
              <!--                no-data-text="无数据"-->
              <!--                @change="handleSiteChange"-->
              <!--              >-->
              <!--                <el-option v-if="!formData.payableEntityId" value="">-->
              <!--                  <span style="color:#f00;font-weight: bold">-->
              <!--                    {{ $t('basicData.PleaseSelectThePayableEntity') }}-->
              <!--                  </span>-->
              <!--                </el-option>-->
              <!--                <el-option-->
              <!--                  v-for="item in outletsList"-->
              <!--                  :key="item.id"-->
              <!--                  :label="item.name"-->
              <!--                  :value="item.id"-->
              <!--                />-->
              <!--              </el-select>-->
              <ElSelectV2
                v-model="formData.siteIds"
                :options="outletsList"
                filterable
                clearable
                :multiple="!editData.id"
                size="small"
                :placeholder="$t('operationCenter.PleaseSelect')"
                style="width: 100%"
                no-data-text="无数据"
                @change="handleSiteChange"
              />
            </el-form-item>
          </el-col>

          <!--结算节点《AJD显示》 -->
          <el-col v-if="isAJDTransport" :span="6">
            <el-form-item
              :label="$t('basicData.SettlementNode')"
              prop="settlementNode"
              :rules="{
                required: true,
                message: $t('basicData.CannotBeEmpty'),
                trigger: ['blur', 'change']
              }"
            >
              <el-select
                v-model="formData.settlementNode"
                :placeholder="$t('basicData.PleaseSelect')"
                style="width: 100%;"
                disabled
              >
                <!--派送任务-->
                <el-option
                  :label="$t('basicData.DeliveryTask')"
                  :value="1"
                />
                <!--签收-->
                <el-option
                  :label="$t('basicData.signFor')"
                  :value="2"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 《邮局派送显示》 -->
          <div v-if="isPostalDeliveryBusiness">
            <!-- 服务商渠道 -->
            <el-col :span="6">
              <el-form-item
                :label="$t('GlobalSetObj.ServiceProviderChannels')"
                prop="providerChannelId"
                :rules="{
                  required: true,
                  message: $t('basicData.CannotBeEmpty'),
                  trigger: ['blur', 'change']
                }"
              >
                <el-select
                  v-model="formData.providerChannelId"
                  filterable
                  :placeholder="$t('GlobalSetObj.pleaseSelectChannel')"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in ProviderChannelList"
                    :key="item.id"
                    :label="item.providerChannelName"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <!-- 材积费-->
            <el-col :span="6">
              <el-form-item :label="$t('customerManagements.VolumeBilling')">
                <div class="volume">
                  <el-form-item label="" label-width="5px">
                    <el-checkbox
                      v-model="formData.useVolumeBilling"
                      :false-label="0"
                      :true-label="1"
                    />
                  </el-form-item>

                  <el-form-item
                    label=""
                    label-width="5px"
                    prop="calculationMethod"
                  >
                    <el-select
                      v-model="formData.calculationMethod"
                      :disabled="!formData.useVolumeBilling"
                      :placeholder="$t('operationCenter.PleaseSelect')"
                      style="width: 100px; margin-left: 5px;"
                    >
                      <el-option :value="0" label="*" />
                      <el-option :value="1" label="/" />
                    </el-select>
                  </el-form-item>

                  <el-form-item
                    label=""
                    label-width="5px"
                    prop="calculateBase"
                  >
                    <el-input-number
                      v-model="formData.calculateBase"
                      :controls="false"
                      :disabled="!formData.useVolumeBilling"
                      :max="999999999"
                      :min="0"
                      :placeholder="$t('customerManagements.pleaseInput')"
                      :precision="2"
                      style="margin-left: 5px;"
                    />
                  </el-form-item>
                </div>
              </el-form-item>
            </el-col>
          </div>
        </el-row>
      </el-form>

      <!--价格详情-->
      <div class="title">{{ $t('basicData.PriceDetails') }}</div>

      <div>
        <!--分区选择-->
        <div v-if="formData.partitionId" class="flex mb10">
          <label class="el-form-item__label" style="line-height: 32px;">
            {{ $t('basicData.PartitionName') }}：
          </label>
          <QueryPartVCmp
            :val="formData.partitionAffiliateId"
            :list="subregionList"
            :clearable="false"
            style="width: 400px;"
            @change="val => formData.partitionAffiliateId = val"
          />
        </div>

        <!--运输干支线且报价类型为车线报价车线选择-->
        <div v-if="formData.businessType === 5 && formData.quoteType === 1" class="flex mb10">
          <label class="el-form-item__label" style="line-height: 32px;">
            {{ $t('basicData.routeName') }}：
          </label>
          <el-select
            v-model="formData.partitionAffiliateId"
            filterable
            :placeholder="$t('operationCenter.PleaseSelect')"
            :clearable="false"
            style="width: 400px;"
            size="small"
          >
            <el-option
              v-for="item in stitchingLine"
              :key="item.id"
              :label="`${item.name}（${item.code}）`"
              :value="item.id"
            />
          </el-select>
        </div>

        <!-- AJD【大件】、DSP派送及安俊小屋、MDD操作按钮 -->
        <template v-if="shouldShowOperationButtons">
          <div class="mb10 feet-r">
            <el-button
              v-permit:remove="'btn:payable:quoteManagement:addEdit'"
              size="small"
              type="primary"
              @click="handleAddRow"
            >
              {{ $t('basicData.AddARow') }}
            </el-button>

            <el-popover placement="bottom-start" trigger="hover">
              <ImportDownload
                :key="exportKey"
                :expense-type-list="expenseTypeList"
                :table-data-obj="tableDataStructure"
                :table-data="{ formData, subregionList }"
                @importPartition="handleImportData"
              />
              <template #reference>
                <el-button size="small" plain>
                  {{ $t('basicData.ImportDownload') }}
                </el-button>
              </template>
            </el-popover>

            <el-popover placement="bottom-start" trigger="hover">
              <div class="feet">
                <el-button
                  size="small"
                  type="primary"
                  @click="clearOffers(1)"
                >
                  {{ $t('basicData.EmptyCurrentPartition') }}
                </el-button>
                <el-button
                  class="feet-btn"
                  size="small"
                  type="primary"
                  @click="clearOffers(2)"
                >
                  {{ $t('basicData.EmptyAllPartitions') }}
                </el-button>
              </div>
              <template #reference>
                <el-button
                  v-permit:remove="'btn:payable:quoteManagement:addEdit'"
                  size="small"
                  plain
                >
                  {{ $t('basicData.ClearTheOffer') }}
                </el-button>
              </template>
            </el-popover>
          </div>
        </template>
      </div>

      <!-- 安俊小屋 -->
      <template v-if="isAnjunHouse">
        <el-form
          ref="tableForm1"
          :model="formData"
          label-width="0"
          label-position="top"
          class="error-form"
          size="mini"
        >
          <el-table :data="formData.collectFeesList" border>
            <!--费用类型-->
            <el-table-column :label="$t('basicData.ExpenseType')" min-width="180">
              <template #header>
                <div>
                  <span style="color: red;">*</span>
                  <span>{{ $t('basicData.ExpenseType') }}</span>
                </div>
              </template>
              <template #default="scope">
                <el-form-item
                  :prop="'collectFeesList.' + scope.$index + '.feeTypeCode'"
                  :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
                >
                  <el-select
                    v-model="scope.row.feeTypeCode"
                    :placeholder="$t('basicData.PleaseSelect')"
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in expenseTypeList"
                      :key="item.id"
                      :label="item.displayName + '(' + item.code + ')'"
                      :value="item.code"
                    />
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <!--货量开始（票）(不包含)-->
            <el-table-column :label="$t('basicData.QuantityStartTicketNotIncluded')" min-width="180">
              <template #header>
                <div>
                  <span style="color: red;">*</span>
                  <span>{{ $t('basicData.QuantityStartTicketNotIncluded') }}</span>
                </div>
              </template>
              <template #default="scope">
                <el-form-item
                  :prop="'collectFeesList.' + scope.$index + '.startOfGoodsQuantity'"
                  :rules="{
                    required: true,
                    suffix: '',
                    negative: 2,
                    negative1: 1,
                    package: scope.row.endOfGoodsQuantity,
                    validator: Integer0,
                    trigger: ['blur', 'change']
                  }"
                >
                  <el-input v-model="scope.row.startOfGoodsQuantity" />
                </el-form-item>
              </template>
            </el-table-column>
            <!--货量结束（票）(包含)-->
            <el-table-column :label="$t('basicData.EndOfVolumeTicketIncluded')" min-width="180">
              <template #header>
                <div>
                  <span style="color: red;">*</span>
                  <span>{{ $t('basicData.EndOfVolumeTicketIncluded') }}</span>
                </div>
              </template>
              <template #default="scope">
                <el-form-item
                  :prop="'collectFeesList.' + scope.$index + '.endOfGoodsQuantity'"
                  :rules="{
                    required: true,
                    suffix: '',
                    negative: 1,
                    negative1: 2,
                    package: scope.row.startOfGoodsQuantity,
                    validator: Integer0,
                    trigger: ['blur', 'change']
                  }"
                >
                  <el-input v-model="scope.row.endOfGoodsQuantity" />
                </el-form-item>
              </template>
            </el-table-column>
            <!--揽收价格-->
            <el-table-column :label="$t('basicData.PickUpPrice')" min-width="180">
              <template #header>
                <div>
                  <span style="color: red;">*</span>
                  <span>{{ $t('basicData.PickUpPrice') }}</span>
                </div>
              </template>
              <template #default="scope">
                <el-form-item
                  :prop="'collectFeesList.' + scope.$index + '.price'"
                  :rules="{ required: true, suffix: 2, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                >
                  <el-input v-model="scope.row.price" />
                </el-form-item>
              </template>
            </el-table-column>
            <!--揽收费补贴-->
            <el-table-column :label="$t('basicData.logisticsSubsidy')" min-width="180">
              <template #default="scope">
                <el-form-item
                  :prop="'collectFeesList.' + scope.$index + '.subsidy'"
                  :rules="{ required: false, suffix: 2, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                >
                  <el-input v-model="scope.row.subsidy" />
                </el-form-item>
              </template>
            </el-table-column>
            <!--操作-->
            <el-table-column :label="$t('basicData.operate')" width="120" fixed="right">
              <template #default="scope">
                <!--确定删除吗？-->
                <el-popconfirm
                  :title="$t('basicData.AreYouSureYouWantToDelete')"
                  @confirm="handleDel(scope.$index, 'collectFeesList')"
                >
                  <!--删除-->
                  <template #reference>
                    <el-button type="danger" size="mini">{{ $t('basicData.Delete') }}</el-button>
                  </template>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </template>

      <!-- DSP派送/AJD【大件】/MDD -->
      <template v-if="isDspBusiness">
        <el-form
          ref="tableForm1"
          :model="formData"
          label-width="0"
          label-position="top"
          class="error-form"
          size="mini"
        >
          <el-table :data="formData.collectFeesList" border>
            <el-table-column :label="$t('basicData.ExpenseType')" min-width="180">
              <template #header>
                <div>
                  <span style="color: red;">*</span>
                  <span>{{ $t('basicData.ExpenseType') }}</span>
                </div>
              </template>
              <template #default="scope">
                <el-form-item
                  :prop="`collectFeesList.${scope.$index}.feeTypeCode`"
                  :rules="expenseTypeRules"
                >
                  <el-select
                    v-model="scope.row.feeTypeCode"
                    :placeholder="$t('basicData.PleaseSelect')"
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in expenseTypeList"
                      :key="item.id"
                      :label="`${item.displayName}(${item.code})`"
                      :value="item.code"
                    />
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <!--重量开始KG（不包含）-->
            <el-table-column :label="$t('basicData.WeightStartKG')" min-width="180">
              <template #header>
                <div>
                  <span style="color: red;">*</span>
                  <span>{{ $t('basicData.WeightStartKG') }}</span>
                </div>
              </template>
              <template #default="scope">
                <el-form-item
                  :prop="`collectFeesList.${scope.$index}.startWeight`"
                  :rules="{
                    required: true,
                    negative: '',
                    suffix: 2,
                    negative1: 1,
                    package: scope.row.endWeight,
                    validator: priceType,
                    trigger: ['blur', 'change']
                  }"
                >
                  <el-input v-model="scope.row.startWeight" />
                </el-form-item>
              </template>
            </el-table-column>
            <!--重量结束KG（包含）-->
            <el-table-column :label="$t('basicData.WeightEndKG')" min-width="180">
              <template #header>
                <div>
                  <span style="color: red;">*</span>
                  <span>{{ $t('basicData.WeightEndKG') }}</span>
                </div>
              </template>
              <template #default="scope">
                <el-form-item
                  :prop="`collectFeesList.${scope.$index}.endWeight`"
                  :rules="{
                    required: true,
                    negative: '',
                    suffix: 2,
                    negative1: 2,
                    package: scope.row.startWeight,
                    validator: priceType,
                    trigger: ['blur', 'change']
                  }"
                >
                  <el-input v-model="scope.row.endWeight" />
                </el-form-item>
              </template>
            </el-table-column>
            <!--0-30KM价格-->
            <el-table-column :label="'0-31KM' + $t('basicData.Price')" min-width="180">
              <template #header>
                <div>
                  <span style="color: red;">*</span>
                  <span>{{ '0-31KM' + $t('basicData.Price') }}</span>
                </div>
              </template>
              <template #default="scope">
                <el-form-item
                  :prop="`collectFeesList.${scope.$index}.innerDistancePrice`"
                  :rules="{ required: true, suffix: 2, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                >
                  <el-input v-model="scope.row.innerDistancePrice" />
                </el-form-item>
              </template>
            </el-table-column>
            <!--'31-101KM价格'-->
            <el-table-column :label="'31-101KM' + $t('basicData.Price')" min-width="180">
              <template #header>
                <div>
                  <!-- <span style="color: red;">*</span>-->
                  <span>{{ '31-101KM' + $t('basicData.Price') }}</span>
                </div>
              </template>
              <template #default="scope">
                <el-form-item
                  :prop="`collectFeesList.${scope.$index}.outerDistancePrice`"
                  :rules="{ required: false, suffix: 2, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                >
                  <el-input v-model="scope.row.outerDistancePrice" />
                </el-form-item>
              </template>
            </el-table-column>
            <!--'>=101KM价格'-->
            <el-table-column :label="'>=101KM' + $t('basicData.Price')" min-width="180">
              <template #header>
                <div>
                  <!-- <span style="color: red;">*</span>-->
                  <span>{{ '>=101KM' + $t('basicData.Price') }}</span>
                </div>
              </template>
              <template #default="scope">
                <el-form-item
                  :prop="`collectFeesList.${scope.$index}.greaterThanDistancePrice`"
                  :rules="{ required: false, suffix: 2, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                >
                  <el-input v-model="scope.row.greaterThanDistancePrice" />
                </el-form-item>
              </template>
            </el-table-column>
            <!--0-31KM超出重量加价（每KG）-->
            <el-table-column :label="'0-31KM' + $t('basicData.ExcessWeightFareIncrease')" min-width="200">
              <template #header>
                <span>{{ '0-31KM' + $t('basicData.ExcessWeightFareIncrease') }}</span>
              </template>
              <template #default="scope">
                <el-form-item
                  :prop="`collectFeesList.${scope.$index}.overWeightExtraPrice`"
                  :rules="{ required: false, suffix: 2, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                >
                  <el-input v-model="scope.row.overWeightExtraPrice" />
                </el-form-item>
              </template>
            </el-table-column>
            <!--'31-101KM超出重量加价（每KG）'-->
            <el-table-column :label="'31-101KM' + $t('basicData.ExcessWeightFareIncrease')" min-width="240">
              <template #header>
                <span>{{ '31-101KM' + $t('basicData.ExcessWeightFareIncrease') }}</span>
              </template>
              <template #default="scope">
                <el-form-item
                  :prop="`collectFeesList.${scope.$index}.overKilometerExtraPrice`"
                  :rules="{ required: false, suffix: 2, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                >
                  <el-input v-model="scope.row.overKilometerExtraPrice" />
                </el-form-item>
              </template>
            </el-table-column>
            <!--'>=101KM超出重量加价（每KG）'-->
            <el-table-column :label="'>=101KM' + $t('basicData.ExcessWeightFareIncrease')" min-width="240">
              <template #header>
                <span>{{ '>=101KM' + $t('basicData.ExcessWeightFareIncrease') }}</span>
              </template>
              <template #default="scope">
                <el-form-item
                  :prop="`collectFeesList.${scope.$index}.greaterThanKilometerExtraPrice`"
                  :rules="{ required: false, suffix: 2, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
                >
                  <el-input v-model="scope.row.greaterThanKilometerExtraPrice" />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column :label="$t('basicData.operate')" width="120" fixed="right">
              <template #default="scope">
                <el-popconfirm
                  :title="$t('basicData.AreYouSureYouWantToDelete')"
                  @confirm="handleDelete(scope.$index, 'collectFeesList')"
                >
                  <template #reference>
                    <el-button type="danger" size="mini">
                      {{ $t('basicData.Delete') }}
                    </el-button>
                  </template>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </template>

      <!-- 第三方揽收 + 上门交件 -->
      <CollectionForwardingCentreHomeDeliveryCmp
        v-if="isCollectionForwardingCentreHomeDeliveryCmp"
        ref="collectionForwardingCentreHomeDeliveryRef"
        :subregion-list="subregionList"
        :partition-id="formData.partitionId"
        :partition-affiliate-id="formData.partitionAffiliateId"
      />

      <!-- 第三方揽收 + 上门揽收 -->
      <CollectionAndDoorToDoorCollectionAndThirdPartyCmp
        v-if="isCollectionAndDoorToDoorCollectionAndThirdParty"
        ref="collectionAndDoorToDoorCollectionAndThirdPartyRef"
        :subregion-list="subregionList"
        :partition-id="formData.partitionId"
        :partition-affiliate-id="formData.partitionAffiliateId"
      />

      <!-- AJD派送 -->
      <AJDAddCmp
        v-if="isBusinessType3AndOperationMode1"
        ref="ajdAddRef"
        :subregion-list="subregionList"
        :partition-id="formData.partitionId"
        :partition-affiliate-id="formData.partitionAffiliateId"
        :table-data="ajdRuleDataList"
      />

      <!-- 运输（干/支线） -->
      <TransportationQuotation
        v-if="isTransportationBusiness"
        ref="transportationQuotation"
        :model-list="modelList"
        :stitching-line="stitchingLine"
        :fee-type-list="expenseTypeList"
        :quotation-type="formData.quoteType"
        :partition-affiliate-id="formData.partitionAffiliateId"
      />

      <!-- 邮局派送 -->
      <PostalDeliveryCmp
        v-if="isPostalDeliveryBusiness"
        ref="PostalDeliveryCmpRef"
        :subregion-list="subregionList"
        :partition-id="formData.partitionId"
        :partition-affiliate-id="formData.partitionAffiliateId"
        :fee-type-list="expenseTypeList"
      />

      <!-- MDD -->
      <!--<MddCmp
        v-if="isMDDBusiness"
        ref="mddRef"
        :subregion-list="subregionList"
        :partition-id="formData.partitionId"
        :partition-affiliate-id="formData.partitionAffiliateId"
        :fee-type-list="expenseTypeList"
        :ids="editData.id"
        :data-list="mddRuleData"
      />-->

      <!-- 其他规则 【AJD、DSP、干支线】、MDD-->
      <OtherCmp
        v-if="shouldShowOtherRules"
        ref="otherRef"
        :subregion-list="subregionList"
        :stitching-line="stitchingLine"
        :special-fee-list="specialFeeList"
        :business-type="formData.businessType"
        :partition-id="formData.partitionId"
        :partition-affiliate-id="formData.partitionAffiliateId"
        :ids="editData.id"
        :quotation-type="formData.quoteType"
        :data-list="otherRuleDataList"
      />
    </div>

    <!--操作按钮-->
    <div class="addFooter">
      <el-button size="small" @click="handleCancel">
        {{ $t('basicData.Cancel') }}
      </el-button>
      <el-button
        v-permit:remove="'btn:payable:quoteManagement:addEdit'"
        size="small"
        type="primary"
        @click="handleSubmit"
      >
        {{ $t('basicData.Save') }}
      </el-button>
    </div>

    <!--保存提示-->
    <el-dialog
      :title="$t('basicData.tips')"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="400"
    >
      <div
        v-for="(item, ind) in errorMessages"
        :key="ind"
        style="color: red; margin-bottom: 8px;"
      >
        {{ item }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">
          {{ $t('basicData.determine') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { apiGetAffiliateById, apiGetPayableOfferPriceById } from '@/api/finance/partition';
import {
  apilistByOfferPriceId,
  apiListByPayableOfferPriceId,
  apiPayableOfferPriceDetailInsert,
  apiPayableOfferPriceDetailUpdate
} from '@/api/finance/basicData';
import toolRequestClass from '@/views/finance/mixins/toolRequestClass';
import { Transport_VEHICLE_MODEL } from '@/views/finance/utils.js';
import { CARGO_TYPE, COLLECT_TYPE, PAYABLE_TYPE } from '@/views/finance/enums';
import { priceType, Integer0 } from './utils';
import ElSelectV2 from 'el-select-v2';

export default {
  components: {
    ElSelectV2,
    QueryPartVCmp: () => import('@/views/finance/cmp/Query/QueryPartV2Cmp.vue'),
    ImportDownload: () => import('./ImportDownload'),
    AJDAddCmp: () => import('./AJDCmp/AJDAddCmp.vue'),
    CollectionForwardingCentreHomeDeliveryCmp: () => import('./CollectionForwardingCentreHomeDeliveryCmp/index.vue'),
    CollectionAndDoorToDoorCollectionAndThirdPartyCmp: () => import('./CollectionAndDoorToDoorCollectionAndThirdPartyCmp/index.vue'),
    PostalDeliveryCmp: () => import('./PostalDelivery/index.vue'),
    TransportationQuotation: () => import('./Transportation/index.vue'),
    // MddCmp: () => import('./MddCmp/index.vue'),
    OtherCmp: () => import('./OtherCmp/index.vue')
  },

  mixins: [toolRequestClass],

  props: {
    // 类型标识 1新增 2编辑 4复制
    operationType: {
      type: Number,
      default: 1
    },
    editData: {
      type: Object,
      default: () => ({})
    },
    // 复制模型 1 基础数据 2 基础数据+其他规则
    copyModel: {
      type: [Number, String],
      default: 0
    }
  },

  data() {
    const checkBeginTime = (rule, value, callback) => {
      if (this.operationType === 2 && this.editData && this.editData.offerPriceStatus === 1) {
        callback();
        return;
      }

      if (!value) {
        callback(new Error(this.$t('basicData.CannotBeEmpty')));
        return;
      }

      callback();
    };

    return {
      PAYABLE_TYPE,
      Transport_VEHICLE_MODEL,
      CARGO_TYPE,
      COLLECT_TYPE,

      rules: {
        name: [
          {
            required: true,
            message: this.$t('basicData.CannotBeEmpty'),
            trigger: ['blur', 'change']
          },
          {
            min: 2,
            max: 50,
            message: this.$t('basicData.TheLengthBetween2And50Characters'),
            trigger: ['blur', 'change']
          }
        ],
        startOfValidityPeriod: [
          {
            required: !(this.operationType === 2 && this.editData?.offerPriceStatus === 1),
            validator: checkBeginTime,
            trigger: ['blur', 'change']
          }
        ],
        businessType: [
          {
            required: true,
            message: this.$t('basicData.CannotBeEmpty'),
            trigger: ['blur', 'change']
          }
        ],
        partitionId: [
          {
            required: false,
            message: this.$t('basicData.CannotBeEmpty'),
            trigger: ['blur', 'change']
          }
        ],
        payableEntityId: [
          {
            required: true,
            message: this.$t('basicData.CannotBeEmpty'),
            trigger: ['blur', 'change']
          }
        ],
        providerChannelId: [
          {
            required: true,
            message: this.$t('basicData.CannotBeEmpty'),
            trigger: ['blur', 'change']
          }
        ],
        transportType: [
          {
            required: true,
            message: this.$t('basicData.CannotBeEmpty'),
            trigger: ['blur', 'change']
          }
        ],
        quoteType: [
          {
            required: true,
            message: this.$t('basicData.CannotBeEmpty'),
            trigger: ['blur', 'change']
          }
        ]
      },

      errorMessages: [],
      dialogVisible: false,
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',

      formData: {
        name: '', // 报价名称
        startOfValidityPeriod: '', // 开始时间
        businessType: '', // 业务类型
        transportType: '', // 运输类型
        quoteType: '', // 报价类型
        collectType: '', // 揽收类型
        cargoType: '', // 货物类型
        partitionId: '', // 分区id,
        partitionName: '', // 分区名称
        payableEntityId: '', // 应付主体
        payableEntityName: '',
        siteIds: [], // 网点id
        siteName: '', // 网点名称,
        settlementNode: 2, // 结算节点
        providerChannelId: '', // 服务商渠道id
        useVolumeBilling: '', // 是否按体积计费
        calculationMethod: '', // 计费方式
        calculateBase: '', // 计费基数
        partitionAffiliateId: '', // 分区关联明细/车线关联明细id
        collectFeesList: [], // 报价费用列表
        feeTypeList: [] // 其他规则列表
      },

      tableDataObj: {
        collectFeesList: {},
        feeTypeList: {}
      },

      tableDataArr: {
        collectFeesList: [],
        feeTypeList: []
      },

      Integer0,
      priceType,
      exportKey: Date.now(),

      feeParams: {
        state: 1, // 1: 启用
        attribute: 2, // 1 应收 2 应付
        accountType: 1 // 1 应付科目 2 成本科目
      },

      ajdRuleDataList: [], // AJD[正常件]规则数据
      mddRuleData: [], // mdd规则
      otherRuleDataList: [], // 其他规则
      subregionList: [] // 分区明细
    };
  },

  computed: {
    // 业务类型相关计算属性
    isAnjunHouse() {
      return this.formData.businessType === 1; // 安骏
    },

    isThirdPartyCollection() {
      return this.formData.businessType === 2; // 第三方
    },

    isAJDTransport() {
      return this.formData.businessType === 3; // AJD
    },

    isDSPTransport() {
      return this.formData.businessType === 4; // DSP
    },

    isTransportationBusiness() {
      return this.formData.businessType === 5; // 干支线
    },

    isPostalDeliveryBusiness() {
      return this.formData.businessType === 6; // 邮局
    },

    isMDDBusiness() {
      return this.formData.businessType === 7; // MDD
    },

    // 是否显示货物类型
    shouldShowCargoType() {
      return [3, 4, 7].includes(this.formData.businessType);
    },
    // 是否显示分区方案
    shouldShowPartitionScheme() {
      return [1, 2, 3, 4, 6, 7].includes(this.formData.businessType);
    },
    // 是否显示网点
    shouldShowOutlets() {
      return ![5, 6].includes(this.formData.businessType);
    },
    // 安骏/DSP组件
    shouldShowOperationButtons() {
      return this.isAnjunHouse || this.isDspBusiness;
    },
    // 是否显示其他规则组件
    shouldShowOtherRules() {
      return [3, 4, 5, 7].includes(this.formData.businessType);
    },
    // AJD正常件
    isBusinessType3AndOperationMode1() {
      return this.isAJDTransport && this.formData.cargoType === 0;
    },
    // 上门交件
    isCollectionForwardingCentreHomeDeliveryCmp() {
      return this.isThirdPartyCollection && this.formData.collectType === 1;
    },
    // 上门揽收
    isCollectionAndDoorToDoorCollectionAndThirdParty() {
      return this.isThirdPartyCollection && this.formData.collectType === 2;
    },
    // DSP/AJD【大件业务】/MDD
    isDspBusiness() {
      return this.isAJDTransport && this.formData.cargoType === 1 || this.isDSPTransport || this.isMDDBusiness;
    },

    // 添加、修改操作
    isAddOperation() {
      return [1, 4].includes(this.operationType);
    },

    // 货物类型
    getCargoTypeRules() {
      return {
        required: this.shouldShowCargoType,
        message: this.$t('basicData.CannotBeEmpty'),
        trigger: ['blur', 'change']
      };
    },
    // 费用类型
    expenseTypeRules() {
      return {
        required: true,
        message: this.$t('basicData.CannotBeEmpty'),
        trigger: ['blur', 'change']
      };
    },

    // 数据存储结构
    tableDataStructure() {
      return this.subregionList?.length > 0 ? this.tableDataObj : this.tableDataArr;
    },

    // 日期限制
    pickerOptions() {
      return {
        disabledDate(time) {
          return time.getTime() <= Date.now() - 24 * 3600 * 1000;
        }
      };
    },
    isDisableData() {
      return this.operationType === 2 && this.editData?.offerPriceStatus === 1;
    }
  },

  watch: {
    // 分区id变更初始价格详情
    'formData.partitionAffiliateId'(val) {
      if (val) {
        this.tableDataObj.collectFeesList[val] = this.tableDataObj.collectFeesList[val] || [];
        this.tableDataObj.feeTypeList[val] = this.tableDataObj.feeTypeList[val] || [];
        this.formData.collectFeesList = this.tableDataObj.collectFeesList[val];
        this.formData.feeTypeList = this.tableDataObj.feeTypeList[val];
      } else {
        this.formData.collectFeesList = this.tableDataArr.collectFeesList;
        this.formData.feeTypeList = this.tableDataArr.feeTypeList;
      }
    },

    'formData.businessType'(val) {
      this.rules.payableEntityId[0].required = val !== 2;
      this.rules.partitionId[0].required = val === 6;

      this.$nextTick(() => {
        this.$refs.queryForm?.clearValidate();
      });
    }
  },

  created() {
    this.initializeData();
  },

  methods: {
    // 初始化方法
    async initializeData() {
      // 获取主体
      this.getProviderList();
      // 运输主体
      this.getTransportationProviderPage();
      // 获取网点
      this.getSiteQuery();
      // 获取分区方案
      this.getSubregionData(2);
      // 获取车型
      this.getApiOptionForSelect();
      // 获取车线
      this.getApiCarLineDispatchSystemList();
      // 获取服务商
      this.getProviderChannel();

      if (this.editData.id) {
        await this.fetchBasicData();
      }
    },
    // 业务场景变化
    changeQuoteType() {
      this.formData.collectType = null;
    },

    // 获取报价详情
    async fetchBasicData() {
      try {
        const res = await apiGetPayableOfferPriceById(this.editData.id);
        if (res.code === 200) {
          this.processFormData(res.data);

          await this.initializeRelatedData();
        }
      } catch (error) {
        console.error('查询报价详情失败:', error);
      }
    },

    processFormData(data) {
      // 主体【快递主体为int，运输主体为string】
      const payableEntityId = this.parsePayableEntityId(data);

      this.formData = {
        name: data.name,
        startOfValidityPeriod: data.startOfValidityPeriod?.replace('T', ' ') || '',
        businessType: data.businessType,
        transportType: data.transportType,
        quoteType: data.quoteType, // 报价类型
        partitionId: data.partitionId,
        partitionName: data.partitionName,
        cargoType: data.cargoType,
        collectType: data.collectType,
        payableEntityId,
        payableEntityName: data.payableEntityName,
        providerBody: data.providerBody,
        code: data.code,
        siteIds: data.siteId,
        siteName: data.siteName,
        settlementNode: data.settlementNode,
        providerChannelId: data.providerChannelId,
        useVolumeBilling: data.useVolumeBilling,
        calculationMethod: data.calculationMethod,
        calculateBase: data.calculateBase,
        partitionAffiliateId: data.partitionAffiliateId,
        collectFeesList: [],
        feeTypeList: []
      };
    },

    // 解析主体id
    parsePayableEntityId(data) {
      if (data.payableEntityId == null) return '';

      if (data.businessType === 5) {
        return String(data.payableEntityId);
      }

      const parsed = parseInt(data.payableEntityId, 10);
      return isNaN(parsed) ? '' : parsed;
    },
    // 查询价格明细
    async initializeRelatedData() {
      const { businessType, payableEntityId } = this.formData;

      // 干支线业务初始分区id
      if (businessType === 5) {
        if (this.stitchingLine.length > 0) {
          this.formData.partitionAffiliateId = this.stitchingLine[0].id;
        }
      } else {
        await this.handlePartitionChange();
      }

      // 获取费用类型
      this.getExpenseTypeList({
        ...this.feeParams,
        businessType
      });

      this.updateProviderData();
      // 主体查网点【排除干支线、邮局】
      if (payableEntityId && ![5, 6].includes(businessType)) {
        this.getSiteQuery(payableEntityId);
      }

      // 复制报价-全部(基础规则)
      if (this.copyModel !== '2') {
        // 获取报价价格详情
        await this.fetchQuoteDetails();
      }

      // 复制报价为其他规则
      if (this.copyModel !== '1') {
        // 获取其他规则详情
        await this.fetchOtherRules();
      }

      this.exportKey = Date.now();
    },

    // 获取报价详情
    async fetchQuoteDetails() {
      try {
        const res = await apiListByPayableOfferPriceId(this.editData.id, false);
        if (res.code !== 200) return;
        // 处理报价详情数据
        const { detailList, detailList2 } = res.data;
        this.processQuoteDetails(detailList, detailList2);
      } catch (error) {
        console.error('查询价格详情失败:', error);
      }
    },

    processQuoteDetails(data, data2) {
      const { businessType, partitionId, partitionAffiliateId } = this.formData;
      // 第三方、干支线、邮局
      if ([2, 5, 6].includes(businessType)) {
        this.handleSpecialBusinessData(data, businessType);
      } else if (this.isBusinessType3AndOperationMode1) { // AJD【正常件】
        this.$nextTick(() => {
          // this.$refs.ajdAddRef?.setData(data);
          this.ajdRuleDataList = data;
        });
      } else if (this.isMDDBusiness) { // MDD
        this.handleNormalBusinessData(data, partitionId);
        this.mddRuleData = data2;
      } else {
        this.handleNormalBusinessData(data, partitionId);
      }

      this.formData.collectFeesList = partitionAffiliateId
        ? this.tableDataObj.collectFeesList[partitionAffiliateId] || []
        : this.tableDataArr.collectFeesList || [];

      this.exportKey = Date.now();
    },

    handleSpecialBusinessData(data) {
      if (this.isCollectionAndDoorToDoorCollectionAndThirdParty) { // 上门揽收
        this.$nextTick(() => {
          this.$refs.collectionAndDoorToDoorCollectionAndThirdPartyRef?.setData(data);
        });
      } else if (this.isCollectionForwardingCentreHomeDeliveryCmp) { // 上门交件
        this.$nextTick(() => {
          this.$refs.collectionForwardingCentreHomeDeliveryRef?.setData(data);
        });
      } else if (this.isTransportationBusiness) { // 干支线
        this.$nextTick(() => {
          this.$refs.transportationQuotation?.setData(data);
        });
      } else if (this.isPostalDeliveryBusiness) { // 邮局
        this.$nextTick(() => {
          this.$refs.PostalDeliveryCmpRef?.setData(data);
        });
      }
    },

    handleNormalBusinessData(data, partitionId) {
      if (!data?.length) return;
      // 安骏、DSP、AJD【大件】
      if (partitionId) {
        const partitionedData = {};
        data.forEach(item => {
          if (!partitionedData[item.partitionAffiliateId]) {
            partitionedData[item.partitionAffiliateId] = [];
          }
          partitionedData[item.partitionAffiliateId].push(item);
        });
        this.tableDataObj.collectFeesList = partitionedData;
      } else {
        this.tableDataArr.collectFeesList = data;
      }
    },

    // 其他规则
    async fetchOtherRules() {
      try {
        const res = await apilistByOfferPriceId(this.editData.id);
        if (res.code === 200 && Array.isArray(res.data)) {
          this.otherRuleDataList = res.data;
        }
      } catch (error) {
        console.error('查询其他规则失败:', error);
      }
    },

    // 切换运输类型更新报价类型
    changeTransportType() {
      // const { businessType, transportType } = this.formData;
      // 运输类型为揽收FM则报价类型只能选择通用报价，否则
      this.formData.quoteType = 2;
    },

    // 报价类型变化，需要同步重置价格详情
    changeQuotationType() {
      const { quoteType } = this.formData;
      // 1.清除车线数据
      this.clearPartitionData();
      // 2.清除明细
      if (quoteType === 1 && this.stitchingLine?.length > 0) {
        this.formData.partitionAffiliateId = this.stitchingLine[0].id;

        this.stitchingLine.forEach(item => {
          this.tableDataObj.collectFeesList[item.id] = [];
          this.tableDataObj.feeTypeList[item.id] = [];
        });
      } else {
        this.tableDataArr.collectFeesList = [];
        this.tableDataArr.feeTypeList = [];
      }
    },

    // 切换业务类型操作
    handleBusinessTypeChange() {
      // 重置表单字段
      this.resetFormFields();
      // 更新价格详情相关数据
      this.updateRelatedData();
    },

    resetFormFields() {
      const resetFields = {
        partitionId: '', // 方案id
        partitionName: '',
        collectFeesList: [], // 价格详情
        feeTypeList: [],
        settlementNode: this.isAJDTransport ? 2 : '', // 结算节点默认值
        collectType: this.isThirdPartyCollection ? this.formData.collectType : '', // 揽收方式
        cargoType: this.isDSPTransport || this.isAJDTransport || this.isMDDBusiness ? this.formData.cargoType : '', // 货物类型
        transportType: '', // 运输类型
        quoteType: '', // 报价类型
        providerChannelId: '', // 服务商
        useVolumeBilling: 0, // 材积费
        calculationMethod: '',
        calculateBase: '',
        payableEntityId: '', // 主体
        payableEntityName: '',
        siteIds: [], // 网点
        siteName: ''
      };

      Object.keys(resetFields).forEach(key => {
        this.formData[key] = resetFields[key];
      });
    },

    updateRelatedData() {
      const { businessType, partitionId } = this.formData;

      // 查询费用
      this.getExpenseTypeList({
        ...this.feeParams,
        businessType
      });

      if (partitionId) {
        this.tableDataObj = { collectFeesList: {}, feeTypeList: {}};
      } else {
        this.tableDataArr = { collectFeesList: [], feeTypeList: [] };
      }

      // 干支线业务需初始车线
      if (this.isTransportationBusiness) {
        this.formData.partitionAffiliateId = this.stitchingLine[0].id;
      }

      this.otherRuleDataList = [];
      this.ajdRuleDataList = []; // AJD[正常件]规则数据
      this.mddRuleData = []; // mdd规则
      this.exportKey = Date.now();
    },

    // 揽收方式改变重置揽收数据
    handleCollectTypeChange() {
      this.formData.collectFeesList = [];
      this.formData.feeTypeList = [];

      if (this.formData.partitionId) {
        this.tableDataObj = { collectFeesList: {}, feeTypeList: {}};
      } else {
        this.tableDataArr = { collectFeesList: [], feeTypeList: [] };
      }

      this.exportKey = Date.now();
    },

    // 非干支线业务通过分区方案id初始分区id
    async handlePartitionChange() {
      const { partitionId } = this.formData;

      if (partitionId) {
        await this.fetchPartitionDetails();
        this.tableDataObj = { collectFeesList: {}, feeTypeList: {}};
      } else {
        this.clearPartitionData();
      }

      this.initializePriceDetails();
    },

    // 查询分区明细
    async fetchPartitionDetails() {
      try {
        const res = await apiGetAffiliateById(this.formData.partitionId, false);
        if (res.code === 200) {
          this.subregionList = res.data.partitionAffiliateList || [];
          if (this.subregionList.length > 0) {
            // 选择分区方案初始分区id
            this.formData.partitionAffiliateId = this.subregionList[0].id;
          }
        }
      } catch (error) {
        console.error('查询分区明细:', error);
      }
    },

    // 不存在方案重置数据
    clearPartitionData() {
      this.formData.partitionName = '';
      this.formData.partitionAffiliateId = '';
      this.tableDataArr = { collectFeesList: [], feeTypeList: [] };
    },

    // 初始价格详情明细
    initializePriceDetails() {
      if (this.subregionList?.length > 0) {
        this.subregionList.forEach(item => {
          this.tableDataObj.collectFeesList[item.id] = [];
          this.tableDataObj.feeTypeList[item.id] = [];
        });
      } else {
        this.tableDataArr.collectFeesList = [];
        this.tableDataArr.feeTypeList = [];
      }
    },

    // 业务主体变更
    handleProviderChange(val) {
      this.resetSiteData();
      this.updateProviderInfo(val);
    },

    // 重置网点
    resetSiteData() {
      this.formData.siteIds = [];
      this.formData.siteName = '';
      // this.outletsList = [];
    },

    // 更新业务主体信息
    updateProviderInfo(val) {
      const providerDataList = this.isTransportationBusiness
        ? this.transportationProviderList
        : this.providerData;

      const matched = providerDataList.find(item => item.id === val);
      this.formData.payableEntityName = matched ? matched.providerName : '';

      // 非干支线、邮局不请求网点
      if (!this.isTransportationBusiness && !this.isPostalDeliveryBusiness) {
        // 主体解析网点
        this.getSiteQuery(val);
      }
    },

    /**
     * 网点变更
     * @param val 新增是多选数组 修改是单选
     */
    handleSiteChange(val) {
      console.log('handleSiteChange', val, this.formData.siteIds);
      if (Array.isArray(val)) {
        // 多选场景：校验所有网点主体是否一致
        const providerIds = this.extractProviderIds(val);
        console.log('providerIds', providerIds);
        if (!providerIds.length) {
          // this.formData.payableEntityId = '';
          // this.handleProviderSearch();
          return;
        }
        if (!this.validateSameProvider(providerIds)) {
          this.$message.warning(this.$t('basicData.MultiplePayableEntitiesExist'));
          this.formData.payableEntityId = '';
          this.handleProviderSearch();
          return;
        }

        // 使用第一个网点的主体ID
        const providerId = providerIds[0];
        this.formData.payableEntityId = providerId;
        this.getProviderIdList(providerId);
      } else {
        // 单选场景：直接设置网点信息
        this.setSingleSiteInfo(val);
      }
    },

    /**
     * 提取网点列表中的主体ID
     * @param {Array} siteIds - 网点ID数组
     * @returns {Array} 主体ID数组
     */
    extractProviderIds(siteIds) {
      return siteIds
        .map(siteId => {
          const matched = this.outletsList.find(outlet => outlet.id === siteId);
          return matched?.providerId;
        })
        .filter(Boolean);
    },

    /**
     * 校验所有主体ID是否相同
     * @param {Array} providerIds - 主体ID数组
     * @returns {Boolean}
     */
    validateSameProvider(providerIds) {
      if (providerIds.length === 0) return false;
      const firstId = providerIds[0];
      return providerIds.every(id => id === firstId);
    },

    /**
     * 设置单个网点信息
     * @param {String|Number} siteId - 网点ID
     */
    setSingleSiteInfo(siteId) {
      const matched = this.outletsList.find(item => item.id === siteId);
      if (!matched) return;

      this.formData.siteName = matched.name;
      this.formData.payableEntityId = matched.providerId;
      this.getProviderIdList(matched.providerId);
    },

    // 远程搜索获取业务主体
    handleProviderSearch(query) {
      this.getProviderList(query);
    },

    // 添加报价（安骏/DSP/AJD【大件】/MDD）
    handleAddRow() {
      const newRow = this.createNewRow();
      // 新增明细
      this.formData.collectFeesList.push(newRow);
      this.updateTableData();
    },

    createNewRow() {
      return {
        partitionAffiliateId: this.formData.partitionAffiliateId,
        feeTypeCode: '',
        billingType: '',
        collectType: this.formData.collectType,
        startOfGoodsQuantity: '',
        endOfGoodsQuantity: '',
        price: '',
        subsidy: '',
        startWeight: '',
        endWeight: '',
        overWeightExtraPrice: '',
        innerDistancePrice: '',
        outerDistancePrice: '',
        greaterThanDistancePrice: '',
        overKilometerExtraPrice: '',
        greaterThanKilometerExtraPrice: ''
      };
    },
    updateTableData() {
      const { partitionAffiliateId, collectFeesList } = this.formData;
      if (partitionAffiliateId) {
        this.tableDataObj.collectFeesList[partitionAffiliateId] = collectFeesList;
      } else {
        this.tableDataArr.collectFeesList = collectFeesList;
      }
      this.exportKey = Date.now();
    },

    // 删除报价
    handleDelete(index, type) {
      this.formData[type].splice(index, 1);
      this.updateTableDataAfterDelete(type);
    },
    updateTableDataAfterDelete(type) {
      if (this.formData.partitionAffiliateId) {
        this.tableDataObj[type][this.formData.partitionAffiliateId] = this.formData[type];
      } else {
        this.tableDataArr[type] = this.formData[type];
      }
      this.exportKey = Date.now();
    },

    // 导入报价
    handleImportData(arr) {
      this.prepareImportDataStructure();

      setTimeout(() => {
        this.processImportedData(arr);
        this.updateFormDataAfterImport();
        this.exportKey = Date.now();
      }, 500);
    },
    prepareImportDataStructure() {
      if (this.subregionList?.length > 0) {
        this.subregionList.forEach(item => {
          this.tableDataObj.collectFeesList[item.id] = this.tableDataObj.collectFeesList[item.id] || [];
        });
      } else {
        this.tableDataArr.collectFeesList = this.tableDataArr.collectFeesList || [];
      }
    },
    processImportedData(arr) {
      for (const item of arr) {
        try {
          if (item.partitionAffiliateId) {
            this.tableDataObj.collectFeesList[item.partitionAffiliateId].push(item);
          } else {
            this.tableDataArr.collectFeesList.push(item);
          }
        } catch (err) {
          this.$message.warning(this.$t('basicData.templatePartition'));
          break;
        }
      }
    },
    updateFormDataAfterImport() {
      this.formData.collectFeesList = this.formData.partitionAffiliateId
        ? this.tableDataObj.collectFeesList[this.formData.partitionAffiliateId] || []
        : this.tableDataArr.collectFeesList || [];
    },

    /**
     * 清空报价
     * @param type 1 清空当前分区 2:清空所有分区
     */
    clearOffers(type) {
      const { businessType, partitionAffiliateId } = this.formData;
      const dataList = businessType === 5 ? this.stitchingLine : this.subregionList;

      this.formData.collectFeesList = [];

      if (dataList?.length > 0) {
        if (type === 1 && partitionAffiliateId != null) {
          this.tableDataObj.collectFeesList[partitionAffiliateId] = [];
        } else {
          dataList.forEach(item => {
            if (item.id != null) {
              this.tableDataObj.collectFeesList[item.id] = [];
            }
          });
        }
      } else {
        this.tableDataArr.collectFeesList = [];
      }
    },

    // 取消
    handleCancel() {
      this.$emit('saveData', false);
    },

    // 提交
    async handleSubmit() {
      await this.validateAndSubmit();
    },

    // 提交数据校验
    async validateAndSubmit() {
      try {
        // 基础数据校验
        const form = await this.$refs.queryForm.validate();
        console.log(form, '===form====');
        // 价格详情校验
        const isTableValid = await this.validateTableData();
        console.log(isTableValid, '====isTableValid===111');
        if (!isTableValid) return;
        // 提交数据处理
        const params = this.buildSubmitParams();
        console.log(params, '===params===111');
        await this.submitData(params);
      } catch (error) {
        console.error('Submit failed:', error);
      }
    },

    async validateTableData() {
      // 其他规则校验
      if (this.shouldShowOtherRules) {
        try {
          const isValid = await this.$refs.otherRef?.submitForm();
          console.log(isValid, '===isValid===2222');
          if (!isValid) return false;
        } catch (error) {
          return false;
        }
      }

      // 上门揽收校验
      if (this.isCollectionAndDoorToDoorCollectionAndThirdParty) {
        return await this.$refs.collectionAndDoorToDoorCollectionAndThirdPartyRef.submitForm();
      }
      // AJD正常件
      if (this.isBusinessType3AndOperationMode1) {
        return await this.$refs.ajdAddRef.submitForm();
      }
      // 上门交件
      if (this.isCollectionForwardingCentreHomeDeliveryCmp) {
        return await this.$refs.collectionForwardingCentreHomeDeliveryRef.submitForm();
      }
      // 邮局校验
      if (this.isPostalDeliveryBusiness) {
        return await this.$refs.PostalDeliveryCmpRef.submitForm();
      }
      // 干支线
      if (this.isTransportationBusiness) {
        return await this.$refs.transportationQuotation.submitForm();
      }
      // MDD价格详情2
      // let flag = true;
      // if (this.isMDDBusiness) {
      //   flag = await this.$refs.mddRef.submitForm();
      // }
      // if (!flag) return false;
      // 安骏/DSP/AJD【大件】/MDD表单校验
      return new Promise(resolve => {
        this.$refs.tableForm1?.validate(resolve);
      });
    },

    buildSubmitParams() {
      const baseParams = {
        name: this.formData.name,
        startOfValidityPeriod: this.formData.startOfValidityPeriod,
        businessType: this.formData.businessType,
        cargoType: this.formData.cargoType,
        partitionId: this.formData.partitionId,
        partitionName: this.formData.partitionName,
        payableEntityId: this.formData.payableEntityId,
        payableEntityName: this.formData.payableEntityName,
        siteIds: this.formatSiteIds(),
        siteName: this.formData.siteName,
        collectType: this.formData.collectType,
        settlementNode: this.formData.settlementNode,
        transportType: this.formData.transportType,
        quoteType: this.formData.quoteType,
        providerChannelId: this.formData.providerChannelId,
        useVolumeBilling: this.formData.useVolumeBilling,
        calculationMethod: this.formData.calculationMethod,
        calculateBase: this.formData.calculateBase,
        detailList: [], // 价格详情
        // detailList2: [], // mdd
        otherRulesList: [] // 其他规则
      };

      this.buildDetailList(baseParams);
      return baseParams;
    },

    // 网点数据解析
    formatSiteIds() {
      if (this.editData.id) {
        return Array.isArray(this.formData.siteIds)
          ? this.formData.siteIds.join(',')
          : this.formData.siteIds;
      }
      return this.formData.siteIds.join(',');
    },
    // 构建详情数据
    buildDetailList(params) {
      if (this.shouldGetDataFromComponents()) {
        return;
      }

      if (this.formData.partitionAffiliateId) {
        Object.values(this.tableDataObj.collectFeesList || {}).forEach(list => {
          if (list?.length > 0) {
            params.detailList.push(...list);
          }
        });
      } else {
        params.detailList.push(...this.tableDataArr.collectFeesList);
      }
      // 价格详情【安骏、DSP、AJD【大件】、MDD】
      this.processFeeTypeCodes(params.detailList);
    },
    // 排除第三方、邮局、干支线、AJD正常件
    shouldGetDataFromComponents() {
      return this.isCollectionForwardingCentreHomeDeliveryCmp ||
        this.isCollectionAndDoorToDoorCollectionAndThirdParty ||
        this.isPostalDeliveryBusiness ||
        this.isBusinessType3AndOperationMode1 ||
        this.isTransportationBusiness;
    },

    processFeeTypeCodes(detailList) {
      detailList.forEach(item => {
        if (item.feeTypeCode?.includes('->')) {
          item.feeTypeCode = item.feeTypeCode.split('->')[1];
        }
      });
    },

    async submitData(params) {
      try {
        const finalParams = await this.getFinalSubmitParams(params);
        // MDD业务需要校验价格详情与价格详情2二选一
        const { detailList, detailList2 } = finalParams;
        if (this.isMDDBusiness && (!detailList.length && !detailList2.length)) {
          this.$message.warning(this.$t('basicData.PleaseAddDetails'));
          return false;
        }
        const API = this.getSubmitAPI();
        console.log(API, 'finalParams-1816', !this.isAddOperation, finalParams);
        const res = await API(finalParams);
        if (res.code === 200) {
          this.$message.success(this.$t('basicData.TheOperationSucceeded'));
          this.$emit('saveData', true);
        }
      } catch (error) {
        console.error('Submit failed:', error);
      }
    },
    // 获取最终提交参数
    async getFinalSubmitParams(params) {
      if (this.isCollectionForwardingCentreHomeDeliveryCmp) { // 上门交件
        params.detailList = this.$refs.collectionForwardingCentreHomeDeliveryRef.getData();
      } else if (this.isCollectionAndDoorToDoorCollectionAndThirdParty) { // 上门揽收
        params.detailList = this.$refs.collectionAndDoorToDoorCollectionAndThirdPartyRef.getData();
      } else if (this.isPostalDeliveryBusiness) { // 邮局
        params.detailList = this.$refs.PostalDeliveryCmpRef.getData();
      } else if (this.isBusinessType3AndOperationMode1) { // AJD【正常件】
        params.detailList = this.$refs.ajdAddRef.getData();
      } else if (this.isTransportationBusiness) { // 干支线
        params.detailList = this.$refs.transportationQuotation.getData();
      } else if (this.isMDDBusiness) { // MDD
        // params.detailList2 = this.$refs.mddRef.getData();
      }

      // 其他规则
      if (this.shouldShowOtherRules) {
        params.otherRulesList = this.$refs.otherRef.getData();
      }

      return {
        ...params,
        id: this.isAddOperation ? null : this.editData.id
      };
    },

    // 提交操作API
    getSubmitAPI() {
      return this.isAddOperation
        ? apiPayableOfferPriceDetailInsert
        : apiPayableOfferPriceDetailUpdate;
    },

    // 其他方法
    updateProviderData() {
      const { payableEntityId, payableEntityName, providerBody, code } = this.formData;

      if (this.operationType !== 1 && payableEntityId && !this.isTransportationBusiness) {
        const exists = this.providerData.some(item => item.id === payableEntityId);
        if (!exists) {
          this.providerData.unshift({
            id: payableEntityId,
            providerName: payableEntityName,
            providerBody,
            code
          });
        }
      }
    },
    // 货物类型禁用选项
    isOptionDisabled(value, type) {
      const { businessType } = this.formData;
      // mdd业务禁用大件
      if (type === 1) {
        return value === 1 && businessType === 7;
      }
      return false;
    }
  }
};
</script>

<style scoped>
.addFormBox {
  padding: 20px;
  height: calc(100vh - 100px);
  overflow-y: auto;
}

.addFooter {
  border-top: 1px solid #ccc;
  text-align: right;
  padding: 10px;
}

.title {
  padding: 15px 10px;
  border-bottom: 1px solid #ccc;
  margin-bottom: 20px;
}

.volume {
  display: flex;
}
</style>
